import { List, useTable, ShowButton } from '@refinedev/antd'
import { Table, Tag, Input, Form, Space } from 'antd'
import type { CrudFilters } from '@refinedev/core'

export { default as OrderShowPage } from './show'

interface OrderRow {
  id: string
  orderNumber: string
  customerName: string
  itemCount: number
  total: number
  currency: string
  paymentStatus: 'PENDING' | 'PAID' | 'FAILED' | 'REFUNDED'
  status: 'PENDING' | 'CONFIRMED' | 'PROCESSING' | 'SHIPPED' | 'DELIVERED' | 'CANCELLED'
  createdAt: string
}

const PAYMENT_COLOR: Record<string, string> = {
  PAID: 'green',
  PENDING: 'gold',
  FAILED: 'red',
  REFUNDED: 'purple',
}
const STATUS_COLOR: Record<string, string> = {
  DELIVERED: 'green',
  SHIPPED: 'blue',
  PROCESSING: 'cyan',
  CONFIRMED: 'geekblue',
  PENDING: 'default',
  CANCELLED: 'red',
}

export function OrdersListPage() {
  const { tableProps, searchFormProps } = useTable<OrderRow>({
    resource: 'orders',
    syncWithLocation: true,
    sorters: { initial: [{ field: 'createdAt', order: 'desc' }] },
    onSearch: (values) => {
      const { search } = values as { search?: string }
      const filters: CrudFilters = [
        { field: 'search', operator: 'contains', value: search || undefined },
      ]
      return filters
    },
  })

  return (
    <List title="Porudžbine">
      <Form {...searchFormProps} layout="inline" style={{ marginBottom: 16 }}>
        <Form.Item name="search">
          <Input.Search
            placeholder="Pretraga po broju porudžbine ili kupcu"
            allowClear
            onSearch={() => searchFormProps.form?.submit()}
            style={{ width: 340 }}
          />
        </Form.Item>
      </Form>

      <Table {...tableProps} rowKey="id">
        <Table.Column title="Broj" dataIndex="orderNumber" sorter />
        <Table.Column title="Kupac" dataIndex="customerName" />
        <Table.Column title="Stavki" dataIndex="itemCount" width={80} />
        <Table.Column
          title="Iznos"
          dataIndex="total"
          sorter
          render={(total: number, r: OrderRow) =>
            `${Number(total).toLocaleString('sr-RS')} ${r.currency}`
          }
        />
        <Table.Column
          title="Plaćanje"
          dataIndex="paymentStatus"
          render={(s: string) => <Tag color={PAYMENT_COLOR[s] ?? 'default'}>{s}</Tag>}
        />
        <Table.Column
          title="Status"
          dataIndex="status"
          render={(s: string) => <Tag color={STATUS_COLOR[s] ?? 'default'}>{s}</Tag>}
        />
        <Table.Column
          title="Datum"
          dataIndex="createdAt"
          sorter
          render={(d: string) => new Date(d).toLocaleDateString('sr-RS')}
        />
        <Table.Column<OrderRow>
          title="Akcije"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <ShowButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  )
}
